// import $ from 'jquery';
import svg4everybody from 'svg4everybody';
import objectFitImages from 'object-fit-images';
import flexibility from 'flexibility';
// import tabslet from 'tabslet';
import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";
import isMobile from './modules/common/is-mobile.js';
import './modules/common/smoothScroll.js';
// import './modules/common/lazyload.js';
import './modules/common/userAgent.js';
import './modules/common/tablefix.js';
import './modules/common/loading.js';
import './modules/top/main-slider-swich.js';
import './modules/top/animation.js';
import './modules/job/animation.js';
import './modules/staff/animation.js';
import './modules/information/swich-tab.js';
import './modules/staff/staff-slider.js';
import './plugins/jquery.fullscreenmenu.js';;

flexibility(document.documentElement);//flexboxのie対応
objectFitImages();//object-fitのie対応
svg4everybody();//svgをieで表示

//電話番号スマホのみ掛ける
$("a[href*='tel']").on("click", function(e){
  if(!isMobile(768)){
    return false
  }
});

$(".information-others__header").on("click", function(e){
  $(this).next().slideToggle();
  $(this).next().toggleClass('is-active');
  $(this).toggleClass('is-active');
});


$('#fullScreenMenu').fullScreenMenu({
  breakpoint: 1040
});

$(window).scroll(function(){
  if ($(this).scrollTop() > 400) {
    $('.c-scrollPageTop').addClass('is-show');
  } else {
    $('.c-scrollPageTop').removeClass('is-show');
  }
});

$(window).on("load resize", function(){
  var window_h = $(window).height();
  if(isMobile(767)){
    $('.top-main-slider__image').css('height',window_h);
  }
});

$(window).on("load resize", function(){
  var sp = '_sp.';
  var pc = '_pc.';
  $(".js-image-switch").each(function(i, v){
    if(!isMobile(767)){
      $(this).attr('src', $(this).attr('src').replace(sp, pc));
    } else {
      $(this).attr('src', $(this).attr('src').replace(pc, sp));
    }
  });
}).trigger("resize");

//
// $(function() {
// 	$('.tabs_default').tabslet({
//     active: 1,
//     mouseevent: 'click',
//     attribute: 'href',
//     animation: true
// 	});
// });

$(function() {
  $('.l-header__nav ul li a[href^="' + location.pathname + '"]').parent().addClass('if-current');
});


const hoge = val => val + 1;
console.log(hoge(1));
